import * as ng from 'angular';
import { OrganismOverviewController, OverviewDataObject } from '../../../../../organisms';

import './domain-transfer-row.scss';

export class MoleculeOverviewRowPanelDomainTransferController implements ng.IController {
    public static $inject: string[] = [];

    public overviewData: OverviewDataObject;
    public OrganismOverview: OrganismOverviewController;
    public overviewLoad: () => any;
    public internalPaginationLimit: number;

    public get showAccounts() {
        return this.OrganismOverview.globals.showAccounts;
    }
}

export class MoleculeOverviewRowPanelDomainTransferComponent implements ng.IComponentOptions {
    public bindings = {
        internalPaginationLimit: '<',
        overviewData: '<',
        overviewLoad: '<'
    };
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public controller =  MoleculeOverviewRowPanelDomainTransferController;
    public template = require('./domain-transfer-row.html');
}
